/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import MaterialPhoneInput from '@orientaction/components/MaterialPhoneInput';
import {
  TURNSTILE_TOKEN_FIELD,
  TurnstileWidget,
  useTurnstile,
} from '@orientaction/components/Turnstile';
import { userService } from '@orientaction/services';
import { isAdmin, publicIconPath } from '@orientaction/utils';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { FC, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import locale from '../../../Authentication/Signup/RegisterForm/locale.json';
import { getRedirectPathByCurrentPahname } from '../../Login';
import style from './style';

interface IProps {
  handleAccountConfirm: any;
  showAccountConfirm: boolean;
  dataStep1: any;
  handlePrevious: any;
}

const SecondStep: FC<IProps> = ({
  handlePrevious,
  dataStep1,
  handleAccountConfirm,
  showAccountConfirm: _showAccountConfirm,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [current, setCurrent] = useState<any>({});
  const [registerError, setRegisterError] = useState<any>({});
  const turnstile = useTurnstile();

  const { search, pathname } = useLocation();
  const history = useHistory();

  const classes = style();

  const verifyFormulaire = () => {
    const errorForm: any = { ...registerError };

    if (!current.phone || current.phone.length <= 2) {
      errorForm.phone = 'Champ obligatoire';
    } else if (!isValidPhoneNumber(current.phone)) {
      errorForm.phone = 'Le format du numéro est invalide';
    } else {
      delete errorForm.phone;
    }

    if (!current.postal_code) {
      errorForm.postal_code = 'Champ obligatoire';
    } else {
      delete errorForm.postal_code;
    }

    setRegisterError(errorForm);
    return Object.keys(errorForm).length > 0;
  };

  const handlePhoneNumberChange = (value: any) => {
    setCurrent({ ...current, phone: value });
  };

  const handleChange = (data: any) => {
    const { name, value } = data.target;
    if (name === 'postal_code' && value !== '' && !/^\d+$/.test(value)) return;
    setCurrent({ ...current, [name]: value });
  };

  const goToPrevious = () => {
    handlePrevious({ data: dataStep1 });
  };

  const onSubmitHandler = async (data: any) => {
    data.preventDefault();
    data.stopPropagation();

    if (verifyFormulaire()) {
      return;
    }

    const turnstileToken = turnstile.getTokenOrError();
    if (!turnstileToken) {
      return;
    }

    setIsLoading(true);
    try {
      const from = new URLSearchParams(search).get('from');
      const secondStepData = { ...current };
      const registerData = await userService.registerUser({
        ...dataStep1,
        ...secondStepData,
        fromTest: from === 'test',
        company: 1,
        username: dataStep1.email,
        confirmed: true,
        [TURNSTILE_TOKEN_FIELD]: turnstileToken,
      });

      if (registerData?.data?.jwt) {
        new Promise((resolve: any) => {
          localStorage.setItem('userInfos', JSON.stringify(registerData?.data?.user));
          localStorage.setItem('userToken', registerData?.data?.jwt);
          resolve(registerData?.data?.jwt);
        }).then(async () => {
          const redirectLink = isAdmin(registerData?.data?.user)
            ? 'admin/users-resultats'
            : getRedirectPathByCurrentPahname(pathname);
          history.push(redirectLink);
        });
      } else if (registerData?.data?.user?.confirmed === false) {
        handleAccountConfirm(true);
      }
    } catch (error) {
      turnstile.reset();
      setRegisterError('Une erreur est survenue');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={classes.formOuter}>
      <form onSubmit={onSubmitHandler} className={classes.form}>
        <div className={classes.fieldsGroup}>
          <div className={classes.fieldWithLabel}>
            <span className={classes.labelPhone}>{locale.phoneLabel}</span>
            <MaterialPhoneInput
              value={current.phone || ''}
              onChange={handlePhoneNumberChange}
              error={!!registerError?.phone}
              style={{
                border: '1px solid #d8d8d8',
                borderRadius: 8,
                height: 40,
              }}
            />
            {registerError?.phone && (
              <span className={classes.errorField}>{registerError.phone}</span>
            )}
          </div>

          <div className={classes.fieldWithLabel}>
            <span className={classes.labelPostal}>{locale.postalCodeLabel}</span>
            <Input
              placeholder={locale.postalCodePlaceholder}
              name="postal_code"
              onChange={handleChange}
              type="text"
              inputMode="numeric"
              inputProps={{ pattern: '[0-9]*' }}
              className={classes.input}
            />
            {registerError?.postal_code && (
              <span className={classes.errorField}>{registerError.postal_code}</span>
            )}
          </div>
        </div>

        {typeof registerError === 'string' && registerError?.trim()?.length > 0 && (
          <span className={classes.registerError}>{registerError}</span>
        )}

        <TurnstileWidget {...turnstile.widgetProps} error={turnstile.error} />

        <div className={classes.submitSection}>
          <Button
            type="submit"
            className={classes.btnConnect}
            disabled={isLoading}
            data-cy="save-user">
            {isLoading ? `${locale.registrationText}...` : locale.registrationText}
          </Button>

          <button type="button" className={classes.backButton} onClick={goToPrevious}>
            <img src={`${publicIconPath}/ArrowLeft.svg`} alt="" width={16} height={16} />
            <span className={classes.backText}>{locale.backText}</span>
          </button>
        </div>
      </form>
    </div>
  );
};

export default SecondStep;
